import Vue from 'vue';
import __vue_component__ from './TreeItem.vue.js';

var script = Vue.extend({
    name: 'Tree',
    props: {
        items: {
            type: Array,
            required: true,
        },
        activeIds: {
            type: Array,
            required: true,
        },
        isClosable: {
            type: Boolean,
            required: false,
            default: true,
        },
        showItemCount: {
            type: Boolean,
            required: false,
            default: true,
        },
        showToplevelFlag: {
            type: Boolean,
            required: false,
            default: false,
        },
        showSubitemFlag: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    methods: {
        onClick: function (itemsArray, isLeaf) {
            if (this.isClosable
                && this.isEqualToActiveItems(itemsArray)
                && !isLeaf) {
                itemsArray.pop();
            }
            this.$emit('itemClick', itemsArray, isLeaf);
        },
        isEqualToActiveItems: function (itemsArray) {
            if (this.activeIds.length !== itemsArray.length) {
                return false;
            }
            return this.activeIds.every(function (itemId, index) { var _a; return itemId === ((_a = itemsArray[index]) === null || _a === void 0 ? void 0 : _a.id); });
        },
    },
    components: {
        TreeItem: __vue_component__,
    },
});

export default script;
